/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from '../SavedWithSuccessModal.html';


class projectWithAlipayController {

  /* @ngInject */

  constructor($log, $q, $timeout, MerchantConfigurationService,
              MerchantVasService, $rootScope, ModalFactory,
              TermsService, NewTokenService, StorageService, CatalogService) {
    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['PROJECT-WITH-ALIPAY'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.lista = [];
    that.selectedPartner = {}

   
    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.updateChange = () => {
      that.currentVas.configuration.partnerId = that.selectedPartner.id
      that.currentVas.configuration.externalFee = that.selectedPartner.externalFee
      console.log(that.currentVas.configuration)
  }

    that.save = () => {
      MerchantVasService.configureVas( that.currentVas.configuration, that.currentVas.id).then((ok) => {
        that.currentVas.configuration = ok.data;
        that.showVasConfigurationSuccess();
      });
    };

    const getPartners = () => {
      MerchantVasService.getPartners().then(
        (response) => {
          that.list = response.data._embedded.alipayPartners
          that.selectedPartner = that.list.find(item => item.id == that.currentVas.configuration.partnerId)
        },
        (error) => {
          console.log(error)
        }
      )  
    }
    
    const init = () => {
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            getPartners()
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    that.$onInit = init;
  }

}

export default projectWithAlipayController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/projectWithAlipay/projectWithAlipay.controller.js
 **/